    import {Role} from './role';
    import {Address} from './address';
    import {TreeNode} from 'primeng/api';


    export class Customer {
        id: string;
        firstName: string;
        lastName: string;
        userName?: any;
        email: string;
        role: Role;
        avatarUrl?: any;
        password?: any;
        billingId?: any;
        channelId?: any;
        addressId?: any;
        phone?: any;
        accountNumber: string;
        poNumber?: any;
        address: Address;
    }

    export class DataNode implements TreeNode {
        data: Customer;
        children: DataNode[];
    }
    